import styled from 'styled-components'

import { DeprecatedText, fromMd } from '@syconium/little-miss-figgy'

export const ErrorMessage = styled.div`
  color: ${o => o.theme.color.deprecated.red.error};
  font-size: 12px;
  margin-top: 10px;
`

export const AccountActivationMessage = styled.span`
  display: flex;
  background: #e9feee;
  border: 1px solid #0c8926;
  color: #0c8926;
  padding: 15px;
  margin-bottom: 15px;
`

export const Content = styled.div`
  padding: 48px 0;
  text-align: center;

  ${fromMd} {
    box-sizing: border-box;
    padding: 0 0 48px 24px;
    width: 50%;
  }
`

export const CheckboxInput = styled.input`
  margin-inline-end: 15px;
  vertical-align: top;
`

export const CheckboxLabel = styled(DeprecatedText)`
  display: inline-block;
  max-width: calc(100% - 32px);
`

export const TermsOfUseContainer = styled.div`
  padding: 25px 0 0;

  a {
    color: ${o => o.theme.color.deprecated.obsidianLight};
  }
`

export const HeaderContainer = styled.div`
  > p {
    padding: 10px 20px 0;
  }
`

export const LoginCta = styled.span`
  color: ${o => o.theme.color.deprecated.obsidianLight};
  text-decoration: underline;
`

export const EmailOptInWrapper = styled.fieldset`
  align-items: start;
  display: flex;
  justify-content: center;
`
